import { render, staticRenderFns } from "./addOilPriceLinkageForm.vue?vue&type=template&id=461e6cb6&scoped=true&"
import script from "./addOilPriceLinkageForm.vue?vue&type=script&lang=js&"
export * from "./addOilPriceLinkageForm.vue?vue&type=script&lang=js&"
import style0 from "./addOilPriceLinkageForm.vue?vue&type=style&index=0&id=461e6cb6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "461e6cb6",
  null
  
)

export default component.exports